import React from 'react';
import { ArrowRight } from 'lucide-react';
import SectionHeader from './SectionHeader';
import useReveal from '../hooks/useReveal';

export default function BannerSection({ id, eyebrow, title, subtitle, image, ctaLabel = 'Tap To Explore', href = '#', height = 'md', overlayText }) {
  const h = height === 'lg' ? 'h-[260px] sm:h-[380px] md:h-[560px]' : 'h-[220px] sm:h-[280px] md:h-[440px]';
  const [ref, visible] = useReveal();
  return (
    <section id={id} ref={ref} style={{ scrollMarginTop: '100px' }} className={`max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-8 sm:py-10 md:py-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="text-center mb-6 sm:mb-8 flex flex-col items-center px-1">
        <SectionHeader eyebrow={eyebrow} title={title} subtitle={subtitle} />
      </div>
      <a href={href} className={`group relative block overflow-hidden rounded-lg ${h}`}>
        {visible ? (
          <img src={image} alt={title} width={1600} height={900} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out" />
        ) : null}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
        {overlayText && (
          <div className="absolute top-4 left-4 sm:top-6 sm:left-6 md:top-10 md:left-10 text-[#F5EFE6] max-w-[85%] sm:max-w-md">
            <p className="text-[9px] sm:text-[10px] tracking-[0.3em] sm:tracking-[0.4em] uppercase opacity-80 mb-1.5 sm:mb-2">{overlayText.eyebrow}</p>
            <p className="font-serif-display text-xl sm:text-2xl md:text-4xl leading-tight">{overlayText.title}</p>
          </div>
        )}
        <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 md:bottom-10 md:left-10">
          <div className="inline-flex items-center gap-2 bg-[#F5EFE6] text-[#1A2332] px-4 sm:px-5 py-2 sm:py-2.5 text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.3em] uppercase rounded-sm group-hover:bg-[#1A2332] group-hover:text-[#F5EFE6] transition-colors">
            {ctaLabel} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </div>
        </div>
        {/* corner ornament */}
        <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-8 h-8 border border-[#F5EFE6]/70 rotate-45"></div>
        </div>
      </a>
    </section>
  );
}
